import { Paper, Grid, Typography } from '@material-ui/core'
import { useTranslation } from 'react-i18next'

import { getComplyAdvantageSearchLink } from '../complianceModal/utils/getComplianceCheckLink'

import styles from './ComplianceDetails.module.scss'
import { DetailsProps, StatusBoxProps } from './ComplianceDetails.types'
import { Button, Spacer } from '@percent/lemonade'
import { CheckList } from './checkList/CheckList'

export function ComplianceDetails({ vettingEventsResults, organisation }: Readonly<DetailsProps>) {
  const { t } = useTranslation()

  const { complyAdvantageSearchId, results } = vettingEventsResults

  const redirectToComplyAdvantage = () =>
    window.open(getComplyAdvantageSearchLink(complyAdvantageSearchId || ''), '_blank', 'noreferrer')

  const indiaNonprofitChecks: Array<{ name: string; status: StatusBoxProps['status'] }> =
    organisation.countryCode === 'IND' && organisation.types?.nonprofit === 'yes'
      ? [
          {
            name: t('typography.fcra'),
            status: organisation.countrySpecificProperties?.fcra ? 'positive' : 'negative'
          }
        ]
      : []

  const australiaChecks: Array<{ name: string; status: StatusBoxProps['status'] }> =
    organisation.countryCode === 'AUS'
      ? [
          {
            name: t('typography.DGR1'),
            status: organisation.countrySpecificProperties?.DGR1 ? 'positive' : 'negative'
          },
          {
            name: t('typography.DGR2'),
            status: organisation.countrySpecificProperties?.DGR2 ? 'positive' : 'negative'
          },
          {
            name: t('typography.DGR4'),
            status: organisation.countrySpecificProperties?.DGR4 ? 'positive' : 'negative'
          }
        ]
      : []

  const otherChecks: Array<{ name: string; status: StatusBoxProps['status'] }> = [
    ...indiaNonprofitChecks,
    ...australiaChecks
  ]

  const mainComplianceChecks = [
    { name: t('form.adverseMedia'), status: results?.adverseMedia?.status },
    { name: t('form.commercial'), status: results?.commercial?.status },
    { name: t('form.controversial'), status: results?.controversial?.status },
    { name: t('form.hateSpeech'), status: results?.hateSpeech?.status },
    { name: t('form.sanction'), status: results?.sanction?.status },
    { name: t('form.warning'), status: results?.warning?.status }
  ]

  return (
    <Grid container spacing={0} component={Paper} elevation={0} className={styles.complianceDetailsContainer}>
      <CheckList
        checks={mainComplianceChecks}
        title={
          <>
            <Typography variant="h6">{t('typography.details')}</Typography>
            {complyAdvantageSearchId && (
              <Button size="small" onClick={redirectToComplyAdvantage}>
                {t('typography.openComplyAdvantage')}
              </Button>
            )}
          </>
        }
      />
      {!!otherChecks.length && (
        <>
          <Spacer size="xxl" axis="vertical" />
          <CheckList checks={otherChecks} title={<Typography variant="h6">{t('typography.otherChecks')}</Typography>} />
        </>
      )}
    </Grid>
  )
}
